export const RESPONSE_CODE_UNAUTHORIZED = 401
export const GET_SUCCESS = 200
export const INSERT_SUCCESS = 201
export const RESPONSE_CODE_DELETE_SUCCESS = 204